import React from 'react';
import { Routes, Route } from 'react-router-dom';
import FuncionariosList from '../components/FuncionariosList';
import FuncionarioForm from '../components/FuncionarioForm';
import FuncionarioDetalhes from '../components/FuncionarioDetalhes';

function FuncionariosPage({ usuario }) {
  const empresaId = usuario?.empresa_id || 1;

  return (
    <Routes>
      <Route path="/" element={<FuncionariosList empresaId={empresaId} />} />
      <Route path="/novo" element={<FuncionarioForm />} />
      <Route path="/editar/:id" element={<FuncionarioForm />} />
      <Route path="/:id" element={<FuncionarioDetalhes />} />
    </Routes>
  );
}

export default FuncionariosPage;